module.exports = __webpack_public_path__ + "static/media/karolina.a3cad93f.jpg";